/**
 * Factory for Postgres single-order domain fetch functions.
 * @module dataAccumulator/createPostgresDomainFetch
 */
import { singleOrderDetailsGenericCallForPostgres } from "../../api/postgreSQL/postCalls/singleOrderDetailsGenericCallForPostgres";
import { SingleOrderDetailsTableName } from "../../enums/singleOrderDetailsTableName";

/**
 * Creates an abortable fetch function for a single Postgres order-details domain.
 *
 * @param tableName - The Postgres table name identifying the domain endpoint
 * @returns A fetch function compatible with {@link useAbortableFetch}
 */
export const createPostgresDomainFetch =
  <T>(tableName: SingleOrderDetailsTableName) =>
  (signal: AbortSignal, orderId: string, orgId: string): Promise<T> =>
    singleOrderDetailsGenericCallForPostgres<T>(
      {
        order_id: orderId,
        org_id: orgId,
        table_name: tableName,
      },
      signal,
    );
